import { _, Backbone } from "../../../../vendor";
import Contingents from "../../../collections/Contingents";
import Products from "../../../collections/Products";
import { Biscuit } from "../../../utils";

/**
 * @function GetContingentItemVoucherFields
 *
 * Compact voucher fields for contingent row item
 * @param int voucherTypeId
 * @param string voucherCode
 * @return object
 */
const GetContingentItemVoucherFields = (voucherTypeId, voucherCode, voucherId) => {
  let voucherFields = {};

  if (voucherTypeId) {
    voucherFields["voucher_type_id"] = voucherTypeId;
    voucherFields["voucher_id"] = voucherId ? voucherId : null;
    voucherFields["voucher_code"] = voucherCode;
  }

  return voucherFields;
};

/**
 * Maps model.summedContingents into native model.contingents
 * so that it can be display on OrderListItemTpl
 *
 * @todo Seems to be unused???
 */
const MapContingentsFromRawToDisplayable = (reservationContingentsListViews) => {
  let contingents = [];

  _.each(reservationContingentsListViews, function (view) {
    _.each(view.collection.models, function (model) {
      contingents.push({
        id: model.get("id"),
        name: model.get("name"),
        contingent_number: model.get("contingent_numbers"),
      });
    });
  });

  return contingents;
};

/**
 * Returns contingents sorted & summed by their amount
 *
 * @return {object} contingents List of contingents
 * @todo Move into ReservationsListHelper.js
 */
const MapContingentsFromRawToGetPrice = (reservationContingentsListViews) => {
  let contingents = {};
  _.each(reservationContingentsListViews, function (view) {
    if (typeof view.contingentId !== "undefined") {
      contingents[view.contingentId] = {};

      _.each(view.collection.models, function (model, count) {
        if (
          typeof model.get("pricetariff_id") === "undefined" ||
          typeof model.get("productId") !== "undefined"
        ) {
          return;
        }
        let pricetariffSelectBox = view.$el.find(".r-contingent-pricetariff");

        if (
          Number(model.get("pricetariff_id")) === 36 &&
          Number(Biscuit.get("user.client_id")) !== 7
        ) {
          let preSelectedPriceTariff = Number(pricetariffSelectBox[0].value);
          model.set("pricetariff_id", preSelectedPriceTariff);
        }
        let singleContingentPrice = {
          amount: 1,
          pricetariff_id: Number(model.get("pricetariff_id")),
          rab_parent_id: Number(model.get("rab_parent_id")),
          ...GetContingentItemVoucherFields(
            model.get("voucher_type_id"),
            model.get("voucher_code"),
            model.get("voucher_id")
          ),
        };

        if (
          //!voucherTypeId
          model.attributes.manual_override &&
          typeof model.attributes.price.price !== "undefined" &&
          Number(model.attributes.price.price) !== null
          /*&& Number(model.attributes.price.tariff_price) != Number(model.attributes.price.price)*/
        ) {
          singleContingentPrice.price = Number(model.attributes.price.price);
          singleContingentPrice.manual_override = true;
        }

        contingents[view.contingentId][count] = singleContingentPrice;
      });
    }
  });
  return contingents;
};

/**
 * Returns contingents with their amounts and pricetariff
 * for POSTing to /reservations
 *
 * @return {object} contingents List of contingents
 */
const MapContingentsFromRawToSave = (reservationContingentsListViews) => {
  let contingents = [{}],
    count = 0;

  _.each(reservationContingentsListViews, function (view) {
    _.each(view.collection.models, function (model) {
      if (
        typeof model.get("pricetariff_id") === "undefined" ||
        typeof model.get("productId") !== "undefined"
      ) {
        return;
      }

      let singleContingentPrice = {
        amount: 1,
        contingent_id: view.contingentId,
        pricetariff_id: Number(model.get("pricetariff_id")),
        ...GetContingentItemVoucherFields(
          model.get("voucher_type_id"),
          model.get("voucher_code"),
          model.get("voucher_id")
        ),
      };

      if (model.attributes.manual_override) {
        singleContingentPrice.price = Number(model.attributes.price.price);
        singleContingentPrice.manual_override = true;
      }

      if (
        typeof model.get("order_item_price_id") !== "undefined" &&
        model.get("order_item_price_id") !== null
      ) {
        singleContingentPrice.order_item_price_id = model.get("order_item_price_id");
        singleContingentPrice.is_updated = true; // model.get('is_updated');
      }

      contingents[0][count] = singleContingentPrice;

      count++;
    });
  });

  // Should output something similiar to this query:
  // https://docs.google.com/document/d/1lEXlfVOKfNhuX2iIrBbwkKMHHf8AW2jxNmxYbA7hilo/edit?ts=5bee9277
  return contingents[0];
};

/**
 * @function MapContingentsReservationsToSummedContingents
 *
 * Map raw model contingents array into
 * an actual collection that can be used
 * internally by ReservationContingentsList
 *
 * @param Backbone.Model
 */
const MapContingentsReservationsToSummedContingents = (model) => {
  let summedContingents = {};

  _.each(model.get("contingents_reservations"), function (contingent, key) {
    const full_contingent_data = _.findWhere(model.get("contingents"), {
      id: contingent.contingent_id,
    });

    if (typeof full_contingent_data === "undefined") {
      return;
    }

    contingent.id = full_contingent_data.id;
    contingent.name = full_contingent_data.name;
    contingent.picture = full_contingent_data.picture;
    contingent.resourcetype_id = full_contingent_data.resourcetype_id;
    contingent.tags = full_contingent_data.tags;
    contingent.rab_parent_id = Number(full_contingent_data.external_contingent_id);
    contingent.order_item_price_id =
      typeof contingent.order_item_price_id !== "undefined" ? contingent.order_item_price_id : null;
    contingent.is_updated = false;

    for (let i = 0; i != contingent.amount; i++) {
      if (typeof summedContingents[contingent.contingent_id] == "undefined") {
        summedContingents[contingent.contingent_id] = new Contingents(contingent);
      } else {
        // Clone contingent WITHOUT previous id, WITHOUT reference
        const clone = _.clone(contingent);
        clone.baseContingentId = clone.contingent_id; // @todo Put EITHER here OR in ReservationContingentsList
        clone.id += key + i; // ID could be left, but well...

        summedContingents[contingent.contingent_id].add(clone);
      }
    }
  });

  model.attributes.summedContingents = summedContingents;
};

/**
 * @function MapProductsReservationsToSummedProducts
 *
 * Map raw model contingents array into
 * an actual collection that can be used
 * internally by ReservationContingentsList
 *
 * @param Backbone.Model
 */
const MapProductsReservationsToSummedProducts = (model) => {
  let summedProducts = {};

  _.each(model.get("products"), function (products, productId) {
    _.each(products, function (product, key) {
      product.order_item_price_id =
        typeof product.order_item_price_id !== "undefined" ? product.order_item_price_id : null;
      product.is_updated = false;

      if (typeof summedProducts[product.product_id] == "undefined") {
        summedProducts[product.product_id] = new Products(product);
      } else {
        // Clone contingent WITHOUT previous id, WITHOUT reference
        const clone = _.clone(product);
        clone.productId = clone.product_id; // @todo Put EITHER here OR in ReservationContingentsList
        clone.id += key; // ID could be left, but well...

        summedProducts[product.product_id].add(clone);
      }
    });
  });
  model.attributes.summedProducts = summedProducts;
};

/**
 * Maps model.summedContingents into native model.contingents
 * so that it can be display on OrderListItemTpl
 *
 * @todo Seems to be unused???
 */
const MapProductsFromRawToDisplayable = (reservationProductsListViews) => {
  let contingents = [];

  _.each(reservationProductsListViews, function (view) {
    _.each(view.collection.models, function (model) {
      contingents.push({
        id: model.get("id"),
        name: model.get("name"),
        contingent_number: model.get("contingent_numbers"),
      });
    });
  });

  return contingents;
};

/**
 * Returns contingents sorted & summed by their amount
 *
 * @return {object} contingents List of contingents
 * @todo Move into ReservationsListHelper.js
 */
const MapProductsFromRawToGetPrice = (reservationProductsListViews) => {
  let products = {};
  _.each(reservationProductsListViews, function (view) {
    if (typeof view.productId !== "undefined") {
      products[view.productId] = {};
      _.each(view.collection.models, function (model, count) {
        let singleProductPrice = {
          product_id: view.productId,
          name: model.get("description"),
          amount: model.attributes.price.amount,
          single_price: model.attributes.price.single_price,
        };

        if (
          model.attributes.manual_override &&
          typeof model.attributes.price.price !== "undefined" &&
          Number(model.attributes.price.price) !== null
        ) {
          singleProductPrice.price = Number(model.attributes.price.price);
          singleProductPrice.manual_override = true;
        }

        products[view.productId][count] = singleProductPrice;
      });
    }
  });
  return products;
};

/**
 * Returns contingents with their amounts and pricetariff
 * for POSTing to /reservations
 *
 * @return {object} contingents List of contingents
 */
const MapProductsFromRawToSave = (reservationProductsListViews) => {
  let products = {};
  _.each(reservationProductsListViews, function (view) {
    if (typeof view.productId !== "undefined") {
      products[view.productId] = {};
      _.each(view.collection.models, function (model, count) {
        let singleProductPrice = {
          product_id: view.productId,
          name: model.get("description"),
          amount: model.attributes.price.amount,
          single_price: model.attributes.price.single_price,
        };

        if (
          model.attributes.manual_override &&
          typeof model.attributes.price.price !== "undefined" &&
          Number(model.attributes.price.price) !== null &&
          Number(model.attributes.price.tariff_price) != Number(model.attributes.price.price)
        ) {
          singleProductPrice.price = Number(model.attributes.price.price);
          singleProductPrice.manual_override = true;
        }

        products[view.productId][count] = singleProductPrice;
      });
    }
  });
  return products;
};
const GetPriceHelper = Backbone.Model.extend({
  url: "/prices/getPrice",
  headers: {
    "Accept-Language": Biscuit.get("user.lang").replace("-", "_"),
  },
});

const WeekdaysMap = {
  0: "mon",
  1: "tue",
  2: "wed",
  3: "thu",
  4: "fri",
  5: "sat",
  6: "sun",
};

export {
  GetContingentItemVoucherFields,
  MapContingentsReservationsToSummedContingents,
  MapContingentsFromRawToSave,
  MapContingentsFromRawToGetPrice,
  MapContingentsFromRawToDisplayable,
  MapProductsReservationsToSummedProducts,
  MapProductsFromRawToDisplayable,
  MapProductsFromRawToSave,
  MapProductsFromRawToGetPrice,
  GetPriceHelper,
  WeekdaysMap,
};
